import { render, staticRenderFns } from "./cliente.buscador.vue?vue&type=template&id=b39fdf3a&scoped=true&"
import script from "./cliente.buscador.vue?vue&type=script&lang=js&"
export * from "./cliente.buscador.vue?vue&type=script&lang=js&"
import style0 from "./cliente.buscador.vue?vue&type=style&index=0&id=b39fdf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39fdf3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VExpandTransition,VIcon,VProgressCircular,VRow,VTextField})
